<template>
    <div class="exportWrap">
        <el-button type="button" @click="submitExport" class="el-button el-button--primary el-button--small" :loading="loading"><span>导出</span></el-button>
        <form ref="myForm" action="" v-show="false" method="get">
            <input type="text" name="token" v-model="token" />
            <input type="text" name="url" v-model="linkHref" />
            <input type="submit" id="submitBtn">
        </form>
    </div>
</template>
<script>
    import store from '@/store'
    export default {
        name: 'LyExportButton',
        props: {
            link: {
                type: String,
                default: ''
            }
        },
        created() {
            this.api = store.getters.objApi.IMPORT_API;
            this.ajaxApi = store.getters.objApi.BASE_API;
        },
        data () {
            return {
                api: '',
                ajaxApi: '',
                token: store.getters.token.access_token,
                linkHref: '',
                loading: false
            }
        },
        methods: {
            submitExport () {
                let vm = this;
                this.$refs.myForm.action = this.ajaxApi + '/manage/download';
                this.linkHref = this.api + this.link;
                this.$nextTick(function () {
                    vm.$refs.myForm.submit();
                })
            }
        }
    }
</script>
<style lang="less">
  .el-button + .exportWrap {
    margin-left: 10px;
  }
  .exportWrap {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/export-button/index.vue